import { SelectFormFieldOption } from "../SelectFormField";

export const provincesAndTerritories = [
  "British Columbia",
  "Alberta",
  "Saskatchewan",
  "Manitoba",
  "Ontario",
  "Quebec",
  "Newfoundland and Labrador",
  "Prince Edward Island",
  "Nova Scotia",
  "New Brunswick",
  "Yukon",
  "Northwest Territories",
  "Nunavut",
];
